import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import DetailedRegistrationInformation from '../../components/authentication/detailed-registration-information.component';
import WelcomeEngage from '../../components/family/welcome-engage.component'; // do not remove
import { ISettings, IUserOptionalData } from '../../interfaces/authentication';
import IPage from '../../interfaces/page';
import instance from '../../api/api';
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';
import { defaultUserData } from '../../interfaces/family';
import moment from 'moment';
import { useParams, useLocation } from 'react-router-dom';

/**
 * Registration page for user authentication
 * @param props : unused for now
 * @returns void
 */
const RegistrationDetails: React.FunctionComponent<IPage> = props => {

    const [ settings, setSettings ] = useState<ISettings>(defaultUserData.settings);
    const [ isMailchimpSubscribed, setIsMailchimpSubscribed ] = useState<boolean>(false);

    const [ userDetails, setUserDetails ] = useState<IUserOptionalData>({
        firstname:'',
        lastname:'',
        newsletter:false,
        avatar:false,
        country:'',
        state:'',
        birthdate: ""
    });

    const location: any = useLocation();

    const { t } = useTranslation();

    const { lang } = useParams();

    // to get user record
    async function fetchUser() {
        try {
            const userResponse = await instance.get('/user/' + localStorage.userid );
            setSettings(userResponse.data.settings);
        } catch (error) {
            console.log("Failed to get user details", error)
        }
    }

    // to get if user is subscribed to the newsletter in mailchimp already
    // (the response is {status, newsletter}: the newsletter is an interest, not the member status,
    //  as a subscribed contact may well be opted out of the newsletter)
    async function fetcMailchimpMember() {
        try {
            const response = await instance.get('/user/mailchimp/'+ localStorage.userid );
            if (response.data?.newsletter === true){
                setIsMailchimpSubscribed(true)
                setUserDetails(prev => ({
                    ...prev,
                    newsletter: true
                }));
            }
        } catch (error) {
            console.log("Failed to get data from Mailchimp", error)
        }
    }

    useEffect(() => {
        fetchUser();
        fetcMailchimpMember()
        // Check if user came from Google OAuth and pre-fill their data
        if (location.state?.fromGoogle) {
            setUserDetails(prev => ({
                ...prev,
                firstname: location.state.firstname || '',
                lastname: location.state.lastname || '',
                avatar: location.state.avatar || false
            }));
        }
    }, [])

    useEffect(() => {
        if(lang) {
            i18n.changeLanguage(lang);
            setSettings((prev: any) => { return {...prev, language: lang ? lang : "en"}}); // saved twice, not nice
        }
    }, [lang])

    useEffect(() => {
            setSettings((prev: any) => { return {...prev, updates: {...settings.updates, monthly: userDetails.newsletter}}});
    }, [userDetails])

    async function updateUserData() {

        const details = {
            firstname: userDetails.firstname,
            lastname: userDetails.lastname,
            country: userDetails.country,
            state: userDetails.state,
            birthdate: moment(userDetails.birthdate).utc(true),
            settings: settings
        }

        try {
            await instance.put('/user/' + localStorage.userid, {details: details});
            // navigation is owned by DetailedRegistrationInformation (gated on whether a FastSpring checkout opens)
        }
        catch(error) {
            console.log('error', error)
        }
    }

    return(
        <Container className="registration-details-container">
            <p className="title">{t("Account")}</p>
            <DetailedRegistrationInformation
                setUserDetails={setUserDetails}
                userDetails={userDetails}
                updateUserData={updateUserData}
                subscriptionData={location.state}
                isMailchimpSubscribed={isMailchimpSubscribed}
                lang={lang}
            />
        </Container>
    );
};

export default RegistrationDetails;
